export default __webpack_public_path__ + "static/media/Thanksgiving wreath.2cfa9ce9.jpg";